/**
 * Creates a random number within a range.
 * @param range   [Minimum, maximum] numbers in a range.
 * @returns Random number within the [minimum, maximum] range.
 */
export const randomInRange = (range) => typeof range === "number"
    ? range
    : Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
//# sourceMappingURL=range.js.map